/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyEmailVerificationMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyEmailVerification. */
export class FamilyEmailVerification {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyEmailVerification.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls the VerificationClient API to generate a security code and sends it to the email address.
   * @summary Generates a security code that is sent to the email address of the member.
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  generateCode(csid: string, options?: Models.FamilyEmailVerificationGenerateCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  generateCode(csid: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  generateCode(csid: string, options: Models.FamilyEmailVerificationGenerateCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  generateCode(csid: string, options?: Models.FamilyEmailVerificationGenerateCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      generateCodeOperationSpec,
      callback);
  }

  /**
   * Calls the VerificationClient API to verify the security code of the email address.
   * @summary Verifies the security code for the email address.
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  verifyCode(csid: string, options?: Models.FamilyEmailVerificationVerifyCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  verifyCode(csid: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  verifyCode(csid: string, options: Models.FamilyEmailVerificationVerifyCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  verifyCode(csid: string, options?: Models.FamilyEmailVerificationVerifyCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      verifyCodeOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const generateCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/email/code",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: {
      serializedName: "body",
      type: {
        name: "String"
      }
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const verifyCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/email/verify",
  urlParameters: [
    Parameters.csid
  ],
  queryParameters: [
    Parameters.updateExternal
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EmailVerificationCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
